export * from "./lib/dokumenter.module";
export * from "./lib/dokument-liste/dokument-liste.component";
